import React from 'react';
import './App.css';
import VentanaCalculator from './components/VentanaCalculator';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';


function App() {
  return (
    <div className="App">
      <div style={{
        background: '#fff3cd',
        borderBottom: '3px solid #f0a500',
        padding: '14px 20px',
        textAlign: 'center',
        fontSize: '15px',
        color: '#5a3e00',
      }}>
        <strong>⚠️ Aviso:</strong> Esta aplicación será dada de baja próximamente.
        Para seguir usando todas las funcionalidades, visita el nuevo sitio:{' '}
        <a
          href="https://cortes.superfil.cl"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#b45309', fontWeight: 'bold', textDecoration: 'underline' }}
        >
          cortes.superfil.cl
        </a>
      </div>
      <VentanaCalculator />
    </div>
  );
}

export default App;